const USER__EVENTS = {
  COMPANY_CHANGED: 'USER__EVENTS.COMPANY_CHANGED',
  PROFILE_CHANGED: 'USER__EVENTS.PROFILE_CHANGED',
};

export default USER__EVENTS;
